import { createFileRoute } from "@tanstack/react-router";
import { MellanoLuukkuProductionPlanningView } from "src/tenantCustomizations/tenants/mellano/views/luukku/productionPlanning/MellanoLuukkuProductionPlanningView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/mellano/luukku/productionPlanning")({
	staticData: { title: "Tuotannon suunnittelu", legacyViewKey: "mellanoLuukkuProductionPlanningView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <MellanoLuukkuProductionPlanningView />;
}
